module.exports = require("flexboxgrid");


/*****************
 ** WEBPACK FOOTER
 ** external "flexboxgrid"
 ** module id = 26
 ** module chunks = 0
 **/